export enum SetupPermissions {
  Setup = 'setup',
  Vo = 'vo',
}
